import { RelatedReference } from "./RelatedReference";

export interface Product {
    id: number;
    title: string;
    slug: string;
    thumbnailUrl: string;
    previewMediaUrls: string[];
    description: string;
    version: string;
    datePosted: string;
    dateUpdated: string;
    game: string;
    platforms: string[];
    tags: string[];
    related?: RelatedReference[];
}

export const blankProduct : Product = {
    id: 0,
    title: "",
    slug: "",
    thumbnailUrl: "",
    previewMediaUrls: [""],
    description: "",
    version: "",
    datePosted: "",
    dateUpdated: "",
    game: "",
    platforms: [""],
    tags: [""],
    related: []
}